export enum PatientStatusType {
  RTSM = 'RTSM',
  STUDY = 'STUDY',
  MEDICATION = 'MEDICATION',
  APP = 'APP',
  VITAL = 'VITAL',
  FINAL_CONTACT = 'FINAL_CONTACT',
}
